/*

    Global popup settings

    enabled_on (array)
        Url path, popup will show on each specified page

    timer (boolean|number)
        If specified popup will show after X amount of time, provide value in miliseconds

    scroll_percent (boolean|number)
        If specified popup will show after X scroll from the top of the page

    outisde_close (boolean)
        If true popup will close after click on outside background

 */
module.exports = function () {
    return {
        frontend_config: [
            // {
            //     popupName1: {
            //         enabled_on: [
            //             "/ibiza-informatie/beachclubs/",
            //             "/services/",
            //             "/ibiza-informatie/clubs/"
            //         ],
            //         timer: false,
            //         scroll_percent: 25,
            //         outside_close: true
            //     }
            // },
            // {
            //     popupName2: {
            //         enabled_on: [
            //             "/ibiza-informatie/stranden/",
            //         ],
            //         timer: 10000,
            //         scroll_percent: false,
            //         outside_close: true
            //     }
            // },
            // {
            //     popupName3: {
            //         enabled_on: [
            //             "/veel-gestelde-vragen/",
            //         ],
            //         timer: false,
            //         scroll_percent: 25,
            //         outside_close: false
            //     }
            // }
        ],
    }
};